/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchResultDTOFromJSON, SearchResultDTOToJSON, } from './SearchResultDTO';
/**
 * @export
 */
export const SearchResultPricingDTOStatusEnum = {
    Pending: 'PENDING',
    InQueue: 'IN_QUEUE',
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * @export
 */
export const SearchResultPricingDTOFailureReasonEnum = {
    InvalidAsinMarketplace: 'INVALID_ASIN_MARKETPLACE',
    MissingPayload: 'MISSING_PAYLOAD',
    ApiError: 'API_ERROR',
    RateLimit: 'RATE_LIMIT'
};
/**
 * Check if a given object implements the SearchResultPricingDTO interface.
 */
export function instanceOfSearchResultPricingDTO(value) {
    return true;
}
export function SearchResultPricingDTOFromJSON(json) {
    return SearchResultPricingDTOFromJSONTyped(json, false);
}
export function SearchResultPricingDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'searchResult': json['searchResult'] == null ? undefined : SearchResultDTOFromJSON(json['searchResult']),
        'status': json['status'] == null ? undefined : json['status'],
        'lowestPrice': json['lowestPrice'] == null ? undefined : json['lowestPrice'],
        'buyboxPrice': json['buyboxPrice'] == null ? undefined : json['buyboxPrice'],
        'totalOfferCount': json['totalOfferCount'] == null ? undefined : json['totalOfferCount'],
        'fbaOfferCount': json['fbaOfferCount'] == null ? undefined : json['fbaOfferCount'],
        'fbmOfferCount': json['fbmOfferCount'] == null ? undefined : json['fbmOfferCount'],
        'amazonOfferCount': json['amazonOfferCount'] == null ? undefined : json['amazonOfferCount'],
        'primeOfferCount': json['primeOfferCount'] == null ? undefined : json['primeOfferCount'],
        'targetSellerCount': json['targetSellerCount'] == null ? undefined : json['targetSellerCount'],
        'targetResolvedSellerCount': json['targetResolvedSellerCount'] == null ? undefined : json['targetResolvedSellerCount'],
        'targetCnSellerCount': json['targetCnSellerCount'] == null ? undefined : json['targetCnSellerCount'],
        'targetCnShipOfferCount': json['targetCnShipOfferCount'] == null ? undefined : json['targetCnShipOfferCount'],
        'targetSellerOrigin': json['targetSellerOrigin'] == null ? undefined : json['targetSellerOrigin'],
        'failureReason': json['failureReason'] == null ? undefined : json['failureReason'],
    };
}
export function SearchResultPricingDTOToJSON(json) {
    return SearchResultPricingDTOToJSONTyped(json, false);
}
export function SearchResultPricingDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'searchResult': SearchResultDTOToJSON(value['searchResult']),
        'status': value['status'],
        'lowestPrice': value['lowestPrice'],
        'buyboxPrice': value['buyboxPrice'],
        'totalOfferCount': value['totalOfferCount'],
        'fbaOfferCount': value['fbaOfferCount'],
        'fbmOfferCount': value['fbmOfferCount'],
        'amazonOfferCount': value['amazonOfferCount'],
        'primeOfferCount': value['primeOfferCount'],
        'targetSellerCount': value['targetSellerCount'],
        'targetResolvedSellerCount': value['targetResolvedSellerCount'],
        'targetCnSellerCount': value['targetCnSellerCount'],
        'targetCnShipOfferCount': value['targetCnShipOfferCount'],
        'targetSellerOrigin': value['targetSellerOrigin'],
        'failureReason': value['failureReason'],
    };
}
